import React from 'react';
import { MegapackLanding } from './pages/MegapackLanding';
export function App() {
  return <MegapackLanding data-id="element-0" />;
}